<template>
  <MonitorWrapper class-name="bc500-container">
    <Details :data="pageTopData">
      <template #sample="{ val }">
        <el-button
          size="mini"
          type="primary"
          :loading="openLoading"
          @click="setSwitch(val.open)"
          :disabled="val.open === -1"
        >
          {{ val.open === 1 ? '关闭' : '开启' }}
        </el-button>
      </template>
    </Details>
    <Charts :options="chartConfigs"></Charts>
  </MonitorWrapper>
</template>

<script>
import MonitorMixin from '@/mixins/monitorMixin';
import Details from './components/details.vue';
import Charts from './components/charts.vue';
import { chartConfigs } from '@/utils/deviceDict/bc500';
import { setSwitch } from '@/api/deviceSetting';
import { mapMutations } from 'vuex';

export default {
  mixins: [MonitorMixin],
  components: {
    Details,
    Charts
  },
  data() {
    return {
      pageTopData: {},
      chartConfigs,
      openLoading: false
    };
  },
  methods: {
    ...mapMutations('bc500', ['disableSetting', 'enableSetting']),
    setSwitch(val) {
      this.openLoading = true;
      const states = [1, 0];
      setSwitch({
        sn: this.sn,
        deviceType: this.deviceType,
        currState: states[val]
      })
        .then(res => {
          this.$message.success(res.message);
        })
        .finally(() => {
          this.openLoading = false;
        });
    },
    updatePageTop(data) {
      const sysMod = data.mods.sysMod;
      const sampleMod = data.mods.sampleMod;
      this.pageTopData = {
        name: data.name,
        sn: data.sn,
        state: data.state,
        runstate: data.runstate,
        temp: sysMod.temp,
        humidity: sysMod.humidity,
        pressure: sysMod.pressure,
        sampleState: sampleMod.sampleState,
        sampleResult: sampleMod.sampleResult,
        sampleNum: sampleMod.sampleNum,
        vehicleState: sysMod.vehicleState,
        doorState: sysMod.doorState,
        sampleFlow: sampleMod.sampleFlow,
        sampleCountDown: sampleMod.sampleCountDown,
        wifiState: sysMod.wifiEnableState,
        batteryCapacity: sysMod.batteryCapacity,
        sampleStandardVolume: sampleMod.sampleStandardVolume,
        sampleVolume: sampleMod.sampleVolume
      };
    },
    chartDataOverflowHandler() {
      this.chartConfigs.forEach(e => {
        if (e.data.length >= 20) e.data.shift();
      });
    },
    updateChart(data) {
      const time = data.beginTime;
      const { mods } = data || {};
      if (!mods) return;
      const { temp, humidity, pressure } = mods.sysMod || {};
      const { sampleStandardVolume, sampleVolume, sampleFlow } = mods.sampleMod || {};
      const charts = this.chartConfigs;
      const standardVolumeChart = charts[0].data;
      const volumeChart = charts[1].data;
      const flowChart = charts[2].data;
      const tempChart = charts[3].data;
      const humidityChart = charts[4].data;
      const pressureChart = charts[5].data;

      standardVolumeChart.push([time, sampleStandardVolume]);
      volumeChart.push([time, sampleVolume]);
      flowChart.push([time, sampleFlow]);
      tempChart.push([time, temp]);
      humidityChart.push([time, humidity]);
      pressureChart.push([time, pressure]);
    },
    updateData(data) {
      this.updatePageTop(data);
      this.updateChart(data);
      this.chartDataOverflowHandler();
    }
  },
  watch: {
    pageTopData(n) {
      if (n.sampleState === 3) {
        this.disableSetting();
      } else {
        this.enableSetting();
      }
    }
  }
};
</script>

<style lang="scss">
.bc500-container {
  width: 100%;
  height: 100%;
  overflow: hidden;

  --details-padding: 20px 0px;
  --details-row-padding: 8px;
  --details-font-size: 16px;
  --details-label-width: 40%;
  --details-label-align: right;
  --details-height: 35%;

  --charts-wrap-height: calc(100% - 240px);
  --charts-wrap-mt: 18px;
  --charts-gap: 10px;

  @media screen and (max-width: 1200px) {
    --details-padding: 5px 0px;
    --details-row-padding: 4px;
    --details-font-size: 12px;
    --details-label-width: 100%;
    --details-label-align: left;
    --details-height: 30%;

    --charts-wrap-height: calc(100% - 30% - 20px);
    --charts-wrap-mt: 5px;
    --charts-gap: 5px;
  }

  .bc500-charts {
    height: var(--charts-wrap-height);

    margin-top: var(--charts-wrap-mt);
  }
}
</style>
